import PropTypes from 'prop-types';

const ResourceLinkType = {
  url: PropTypes.string,
  size: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default ResourceLinkType;
